// extracted by mini-css-extract-plugin
module.exports = {"member":"TableRow_member__2PANX","notMember":"TableRow_notMember__1z0U2","active":"TableRow_active__3DiAX","inactive":"TableRow_inactive__10HTB"};